<template>
<div class="content-wrapper">

  <div class="page-header page-header-light">
    <div class="page-header-content header-elements-md-inline" style="height: 40px">
      <div class="page-title d-flex">
        <h5 style="font-size: 14px;">
        {{title}}
        <span v-if="!title">Loading...</span>
        </h5>
        <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
      </div>
    </div>
  </div>

  <div  class="d-flex justify-content-center align-items-center" style="height:100vh" v-if="isLoadingData">
    <loading ></loading>
  </div>
  <div class="card mt-1" v-if="Object.keys(rawData).length && !isLoadingData">
    <div class="card-body">

      <div class="row">
         <div :class="matchKeywordInfo ? 'col-sm-6':'col-sm-8'">
          <div  class="text-info-area" v-html="highlightHTML"></div>
          <div class="d-flex justify-content-end mt-2"><button class="btn btn-info" @click="checkKeyword"><i class="fas fa-spinner spinner mr-1" v-if="isCheckKeyword"></i>Check Matching</button></div>
        </div>

        <div class="col-sm-3" v-if="matchKeywordInfo">

            <div class="card p-2">
            <div><b class="text-success" v-if="matchKeywordInfo.isMatch">Matched</b><b v-else class="text-danger">Not Matched</b></div>
            <div>This message <span class="text-success" v-if="matchKeywordInfo.isMatch">matches</span> <span class="text-danger" v-else>does not match</span> with keywords from <b>kbank</b></div>
            <div v-if="matchKeywordInfo.matchedKeyword.length">
              <span>Matched keyword is &nbsp;</span>
              <span class="text-success">{{matchKeywordInfo.matchedKeyword ? matchKeywordInfo.matchedKeyword.join(", "):"-"}}</span>
            </div>

            <div v-if="matchKeywordInfo.matchedExcludedKeyword.length">
              <span>Matched exclude keyword is &nbsp;</span>
              <span class="text-danger">{{matchKeywordInfo.matchedExcludedKeyword ? matchKeywordInfo.matchedExcludedKeyword.join(", "):"-"}}</span>
            </div>
            </div>

        </div>
        <div class="col-sm-3">

            <div class="media flex-column">
              <div class="row pl-2 bd-highlight">
                <input id="search_field" class="form-control" type="search" placeholder="Search Text" v-model="searchString" ref="search">
              </div>
              <div class="row p-0">
                <div>
                  <button v-if="isNone || isProgress || isReject" type="button" class="btn btn-primary m-2" @click=readData>Read</button>
                  <button v-if="isNone || isProgress || isReject || !countRow" type="button"
                          class="btn btn-primary m-2"
                          @click=updateStatus(statusReview)>
                          Submit review
                  </button>
                </div>
                <div>
                  <button v-if="isAdmin && (isReview || isDone)" type="button" class="btn btn-primary m-2" @click=updateStatus(statusDone) :disabled="isDone">Approve</button>
                  <button v-if="isAdmin && (isReview|| isDone)" type="button" class="btn btn-primary m-2" @click=updateStatus(statusReject) :disabled="isReject">Reject</button>
                </div>
                <div class="pl-2">
                  <button v-if="isAdmin" type="button" class="btn btn-primary mr-2" @click="validateAnswer">Validate</button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="media flex-column flex-sm-row justify-content-between" style="margin-top:0px;">
        <span class="text-success" ><span v-if="score">Score: {{score}} </span></span>
        <span class="text-muted"> Rows: {{countRow}} </span>
      </div>
      <div ref="table"></div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loading from '@/components/Loading'
import Handsontable from 'handsontable'

import moment from 'moment'
import serviceRoutes from '../../service-routes'

export default {
  components: {
    Loading
  },
  created () {
    this.getUndeletedPages()
  },
  data () {
    return {
      score: '',
      isCheckKeyword: false,
      invalidCell: [],
      isLoadingData: true,
      matchKeywordInfo: null,
      hotSettings: {
        undo: false,
        manualColumnResize: true,
        manualRowResize: true,
        colWidths: null,
        height: '450',
        className: 'htLeft',
        data: Handsontable.helper.createSpreadsheetData(4, 4),
        rowHeaders: true,
        colHeaders: null,
        columns: null,
        columnSorting: true,
        multiColumnSorting: true,
        filters: true,
        // dropdownMenu: ['filter_by_condition', 'filter_action_bar', 'filter_by_value'],
        dropdownMenu: {
          items: {
            'clear_filters': {
              // name: 'Clear filter',
              name: '<div class="text-right"><font color="#3c82cc">Clear filter</font></div>',
              callback: this.removeConditions
            },
            'hsep3': '---------',
            'filter_by_condition': {},
            'filter_by_value': {},
            'filter_action_bar': {}
          }
        },
        search: true,
        contextMenu: {
          items: {
            'row_below': {
              name: 'Duplicate row',
              callback: this.duplicate
            },
            'remove_row': {
              name: 'Delete row',
              callback: this.deleteRow
            }
            // 'clear_filters': {
            //   name: 'Clear filter',
            //   callback: this.removeConditions
            // }
          }
        },
        afterChange: (changes) => {
          if (changes) {
            for (let change of changes) {
              let index = change[0]
              this.changeData(index)
            }
          }
        },
        afterSelection: (row, column) => {
          this.text = this.hot.getDataAtCell(row, column)
          this.countRow = this.hot.getData() ? this.hot.getData().length : 0
          this.highlightAndValidate(false)
        },
        afterFilter: async () => {
          console.time('highlight + validate')
          await this.highlightAndValidate()
          console.timeEnd('highlight + validate')
        },
        afterValidate: (isValid, value, row, prop, source) => {
          if (!isValid) {
            this.invalidCell.push(row)
          }
        },
        cells: (row, col) => {
          let columns = this.hotSettings.columns.map(col => col.data)
          let brandIndex = columns.indexOf('Brand')
          let channelIndex = columns.indexOf('Channel')
          let productIndex = columns.indexOf('Product/Other')
          let subIndex = columns.indexOf('Sub Attribute')
          let intentionIndex = columns.indexOf('Intention')

          const cellProperties = {}
          if (this.hot && this.hotSettings && this.hotSettings.data[row] && this.hotSettings.data[row].incorrect_ans) {
            let incorrectAns = this.hotSettings.data[row].incorrect_ans
            if (brandIndex === col) {
              if (incorrectAns['Brand'] === false) {
                cellProperties.className = 'bg-danger'
              }
            }
            if (channelIndex === col) {
              if (incorrectAns['Channel'] === false) {
                cellProperties.className = 'bg-danger'
              }
            }
            if (productIndex === col) {
              if (incorrectAns['Product/Oter'] === false) {
                cellProperties.className = 'bg-danger'
              }
            }
            if (subIndex === col) {
              if (incorrectAns['Sub Attribute'] === false) {
                cellProperties.className = 'bg-danger'
              }
            }
            if (intentionIndex === col) {
              if (incorrectAns['Intention'] === false) {
                cellProperties.className = 'bg-danger'
              }
            }
          }
          return cellProperties
        }
      },
      searchString: '',
      text: '',
      isDuplicating: false,
      isInProgress: false,
      statusNone: 'None',
      statusReview: 'To review',
      statusDone: 'Done',
      statusReject: 'Reject',
      statusRead: 'Read',
      statusDelete: 'Delete',
      statusInProgress: 'In progress',
      isLoading: false,
      hotTable: null,
      countRow: null,
      undoHistory: [],
      unDeletedPages: [],
      rawData: {}
    }
  },
  computed: {
    ...mapGetters({
      isAuth: 'isAuth',
      duplicateData: 'duplicateData',
      saveData: 'saveData',
      role: 'role',
      username: 'username',
      chunkDataUpdate: 'chunkDataUpdate'
    }),
    title () {
      if (this.rawData && this.rawData.detail) {
        return `Raw data [ ${this.rawData.detail.dataDate ? (moment(this.rawData.detail.dataDate).format('DD/MM/YYYY') + ' - ') : ''}${this.rawData.detail.filename}${(this.rawData.detail.criteria && this.rawData.detail.criteria.category ? ` - ${this.rawData.detail.criteria.category[0]}` : '')} ] - ${this.rawData.detail.assignTo}`
      }
      return ''
    },
    // rawDataResponse () {
    //   return this.rawData
    // },
    chunkId () {
      return this.$route.params._id
    },
    hotRef () {
      return this.$refs.hotTableComponent
    },
    isAdmin () {
      return this.role === 'admin'
    },
    isNone () {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusNone
      }
      return false
    },
    isProgress () {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusInProgress
      }
      return false
    },
    isReview () {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusReview
      }
      return false
    },
    isDone () {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusDone
      }
      return false
    },
    isReject () {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusReject
      }
      return false
    },
    highlightHTML () {
      let textInfo = this.text ? this.text.toLowerCase() : this.text
      if (this.matchKeywordInfo && this.matchKeywordInfo.matchedKeyword.length > 0) {
        for (let keyword of this.matchKeywordInfo.matchedKeyword) {
          textInfo = textInfo.replace(keyword, `<span class="text-success font-weight-bold">${keyword}</span>`)
        }
      }

      if (this.matchKeywordInfo && this.matchKeywordInfo.matchedExcludedKeyword.length > 0) {
        for (let keyword of this.matchKeywordInfo.matchedExcludedKeyword) {
          textInfo = textInfo.replace(keyword, `<span class="text-danger font-weight-bold">${keyword}</span>`)
        }
      }

      return textInfo
    }
  },
  async mounted () {
    // this.tagging()
    window.addEventListener('keydown', async (e) => {
      e = e || window.event
      let key = e.keyCode
      let altKey = e.altKey ? e.altKey : (key === 18)
      let ctrl = e.ctrlKey ? e.ctrlKey : (key === 17)
      if (key === 82 && altKey) {
        console.log('Alt + R Pressed : Read !')
        await this.individualRead()
      } else if (key === 79 && altKey) {
        console.log('Alt + O Pressed : Delete !')
        this.deleteRow()
      } else if (key === 86 && altKey) {
        console.log('Alt + v Pressed : Duplicate !')
        this.duplicate()
      } else if (key === 90 && ctrl) {
        this.undo()
        console.log('Ctrl + Z Pressed !')
      }
      return false
    }, false)

    await this.loadData()

    this.isLoadingData = true
    setTimeout(() => {
      this.init()
    }, 0)
    this.isLoadingData = false
  },
  beforeDestroy () {
    if (this.$swal && typeof this.$swal.close === 'function') {
      this.$swal.close()
    }
  },
  watch: {
    searchString () {
      let search = this.hot.getPlugin('search')
      search.query(this.searchString)
      this.hot.render()
    }
  },
  methods: {
    ...mapActions({
      saveRecords: 'saveRecords',
      updateRecords: 'updateRecords',
      duplicateRecord: 'duplicateRecord',
      updateChunkData: 'updateChunkData',
      deleteRecord: 'deleteRecord'
    }),
    validateAnswer () {
      serviceRoutes.validateTestData(this.$route.params._id).then((data) => {
        let records = data.data
        this.score = `${records.filter(v => v.is_correct).length}/${records.filter(v => v.record_status !== 'Delete').length}`
        this.hot.loadData(records)
        this.hotSettings.data = records
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
      }).catch()
    },
    async loadData () {
      this.rawData = await serviceRoutes.getTestData(this.$route.params._id)
    },
    removeConditions () {
      let selectedCol = this.hot.getSelectedLast()[1]
      const filtersPlugin = this.hot.getPlugin('filters')
      filtersPlugin.removeConditions(selectedCol)
      filtersPlugin.filter()
      if (selectedCol === 1) {
        this.initDefaultFilter()
      }
    },
    async deleteRow () {
      await this.getUndeletedPages()
      let todos = []
      let selectedRows = this.hot.getSelected()
      selectedRows = this.getSelectedRows(selectedRows)
      let cannotDeleteIncident = false
      let undeletedPage = null
      for (let selectedRow of selectedRows) {
        let rowData = this.hot.getDataAtRow(selectedRow)
        let rowDataObj = this.mapDataArrayToObject(rowData)

        if (rowDataObj.is_incident) {
          console.log('cannot delete record from incident')
          cannotDeleteIncident = true
        } else if (this.unDeletedPages.includes(rowDataObj.page.toLowerCase())) {
          console.log('cannot delete record from incident')
          undeletedPage = rowDataObj.page
        } else {
          console.time('delete')
          this.hot.setDataAtCell(selectedRow, 1, 'Delete')
          todos.push(this.mapDataArrayToObject(rowData))
          console.timeEnd('delete')
        }
      }

      if (cannotDeleteIncident) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'warning',
          title: 'Cannot delete record from Incident'
        })
      }

      if (undeletedPage) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'warning',
          title: 'Cannot delete record of page ' + undeletedPage
        })
      }

      this.undoHistory.push(todos)
      this.filter()
    },
    async updateStatus (value) {
      if (value === this.statusReview) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'info',
          title: 'Validating...',
          timer: 0,
          showConfirmButton: false })
        this.initDefaultFilter()
        let datas = this.hotSettings.data.slice(0)
        let valid = this.highlightAndValidate(true)
        if (valid) {
          let dataDone = datas.filter(v => v.record_status === this.statusRead || v.record_status === this.statusDelete)
          if (dataDone.length === datas.length) {
            let res = await serviceRoutes.updateTestChunkData(this.chunkId, { status: value })
            if (res.error) {
              if (res.error.status_code === '40001') {
                this.$swal({
                  toast: true,
                  position: 'top-end',
                  icon: 'error',
                  title: 'Your work has not been completed, please "Reload" your page.',
                  confirmButtonText: 'Reload',
                  showConfirmButton: true,
                  showCloseButton: true })
                  .then((result) => {
                    if (result.value) {
                      location.reload()
                    }
                  })
              } else {
                this.$swal({
                  toast: true,
                  position: 'top-end',
                  icon: 'error',
                  title: 'Something went wrong',
                  confirmButtonText: 'Reload',
                  showConfirmButton: true,
                  showCloseButton: true })
                  .then((result) => {
                    if (result.value) {
                      location.reload()
                    }
                  })
              }
            } else {
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Your work has been submited',
                showConfirmButton: false,
                showCloseButton: true })
            }
            await this.loadData()
          } else {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: 'Some record still not read',
              showConfirmButton: false,
              showCloseButton: true })
          }
        } else {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Your work has not been finished',
            showConfirmButton: false,
            showCloseButton: true })
        }
      } else {
        if (value === this.statusDone) {
          let isValid = this.highlightAndValidate(true)
          if (isValid) {
            let res = await serviceRoutes.updateTestChunkData(this.chunkId, { status: value })
            if (res.error) {
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Your work has not been finished',
                showConfirmButton: false,
                showCloseButton: true })
            } else {
              await this.loadData()
            }
          }
        } else {
          let res = await serviceRoutes.updateTestChunkData(this.chunkId, { status: value })
          if (res.error) {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: 'Your work has not been finished',
              showConfirmButton: false,
              showCloseButton: true })
          } else {
            await this.loadData()
          }
        }
      }
    },
    highlightAndValidate (isFocusInvalidRow = false) {
      let invalidRow = -1
      // console.time('highlight')
      let dataObj = this.hot.getData().map(v => this.mapDataArrayToObject(v))
      let brandIndex = this.hotSettings.columns.map(col => col.data).indexOf('Brand')
      let channelIndex = this.hotSettings.columns.map(col => col.data).indexOf('Channel')
      let productIndex = this.hotSettings.columns.map(col => col.data).indexOf('Product/Other')
      let subIndex = this.hotSettings.columns.map(col => col.data).indexOf('Sub Attribute')
      let intentionIndex = this.hotSettings.columns.map(col => col.data).indexOf('Intention')
      let usernameIndex = this.hotSettings.columns.map(col => col.data).indexOf('user_name')
      // let sensitiveAreaIndex = this.hotSettings.columns.map(col => col.data).indexOf('Sensitive Area')

      let isValid = true
      for (let [row, rec] of dataObj.entries()) {
        if (rec.is_duplicated_by_user) {
          for (let i = 0; i < Object.keys(rec).length - 1; i++) {
            this.hot.setCellMeta(row, i, 'className', 'duplicated')
          }
        }

        if (rec.user_name === 'Anonymous' && rec['Intention'] === 'information/news') {
          this.hot.getCellMeta(row, intentionIndex).valid = false
          this.hot.getCellMeta(row, usernameIndex).valid = false
          isValid = false
        } else {
          this.hot.getCellMeta(row, usernameIndex).valid = true
        }

        if (rec.Channel === 'none' && rec['Sub Attribute'] === 'channel availability') {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec['Sub Attribute'] === 'others') {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec.Channel === 'mobile banking' && rec['Product/Other'] === 'mobile banking') {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }

        if (rec.Channel === 'mobile banking' && rec['Sub Attribute'] === 'service time') {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec['Sub Attribute'] === 'research' && (rec.Channel === 'mobile banking' && rec['Product/Other'] === 'money transfer')) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, productIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec.Channel === 'call center-voice' && (
          rec['Sub Attribute'] === 'channel availability' ||
          rec['Sub Attribute'] === 'ceo' ||
          rec['Sub Attribute'] === 'csr' ||
          rec['Sub Attribute'] === 'ease of use' ||
          rec['Sub Attribute'] === 'err' ||
          rec['Sub Attribute'] === 'fee' ||
          rec['Sub Attribute'] === 'investment/k expert' ||
          rec['Sub Attribute'] === 'notification' ||
          rec['Sub Attribute'] === 'payment' ||
          rec['Sub Attribute'] === 'performance' ||
          rec['Sub Attribute'] === 'privilege' ||
          rec['Sub Attribute'] === 'promotion/campaign' ||
          rec['Sub Attribute'] === 'research' ||
          rec['Sub Attribute'] === 'simplicity'
        )) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if ((rec['Product/Other'] === 'investment' || rec['Product/Other'] === 'mutual fund') && rec['Sub Attribute'] === 'investment/k expert') {
          this.hot.getCellMeta(row, productIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec.Channel === 'none' && ['grab pay wallet', 'digital product', 'mobile banking', 'money transfer', 'line bk'].includes(rec['Product/Other'])) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }

        if (rec['Sub Attribute'] === 'investment/k expert' && ['digital product', 'mutual fund', 'digital asset', 'deposit account(individual)', 'deposit account(juristic)'].includes(rec['Product/Other'])) {
          this.hot.getCellMeta(row, productIndex).valid = false
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec.Brand.includes(',')) {
          this.hot.getCellMeta(row, brandIndex).valid = false
          isValid = false
        }
        if (rec.Channel.includes(',')) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }
        if (rec['Product/Other'].includes(',')) {
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }
        if (rec['Sub Attribute'].includes(',')) {
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }
        if (rec.Intention.includes(',')) {
          this.hot.getCellMeta(row, intentionIndex).valid = false
          isValid = false
        }
        // if (rec['Sensitive Area'].includes(',')) {
        //   this.hot.getCellMeta(row, sensitiveAreaIndex).valid = false
        //   isValid = false
        // }
        if (!isValid && invalidRow < 0) {
          invalidRow = row
        }
      }
      if (isFocusInvalidRow) {
        this.hot.selectRows(invalidRow)
      }
      this.hot.render()
      return isValid
    },
    getSelectedRows (allSelected) {
      let rows = []
      if (allSelected) {
        for (let selected of allSelected) {
          let range = [selected[0], selected[2]]
          range.sort()
          let rowStart = range[0]
          let rowEnd = range[1]
          if (rowStart === rowEnd) {
            rows.push(rowStart)
          } else {
            for (let i = rowStart; i <= rowEnd; i++) {
              rows.push(i)
            }
          }
        }
        rows.sort()
      }
      rows = new Set(rows)
      return rows
    },
    async individualRead () {
      let selectedRows = this.hot.getSelected()
      selectedRows = this.getSelectedRows(selectedRows)
      for (let selectedRow of selectedRows) {
        this.hot.setDataAtCell(selectedRow, 1, 'Read')
      }
    },
    async readData () {
      console.time('read')
      let data = this.hot.getData()
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'Validating...',
        showConfirmButton: false,
        timer: 0 })
      let valid = this.highlightAndValidate(true)
      if (valid) {
        let result = []
        data.map((rec, index) => {
          this.hotSettings.data.find((data, inx) => {
            if (rec[0] === data._id) { result.push(data) }
          })
        })

        let responseData = await serviceRoutes.saveTestRecords(this.chunkId, result)
        let datas = this.hotSettings.data.slice(0)
        responseData.data.map(rec => {
          let row = null
          datas.find((data, index) => {
            if (rec._id === data._id) { row = index }
          })
          datas.splice(row, 1, rec)
        })
        this.hot.loadData(datas)
        this.hotSettings.data = datas
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
        console.timeEnd('read')
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Read all',
          showConfirmButton: false,
          showCloseButton: true })
      } else {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Your work has not been finished',
          showConfirmButton: false,
          showCloseButton: true })
      }
    },
    changeData (index) {
      if (this.$swal && typeof this.$swal.close === 'function') {
        this.$swal.close()
      }
      if (!this.isInProgress && !this.isReview) {
        serviceRoutes.updateTestChunkData(this.chunkId, { status: this.statusInProgress })
        this.isInProgress = true
      }
      let data = this.hot.getData()
      let idOfData = null
      data.find((rec, idx) => {
        if (index === idx) { idOfData = rec[0] }
      })
      if (!this.isDuplicating) {
        for (let record of this.hotSettings.data) {
          if (idOfData === record._id) {
            serviceRoutes.updateTestRecords(this.chunkId, [record])
            break
          }
        }
      }
    },
    async duplicate (key, selection, clickEvent) {
      console.time('duplicate')
      this.isDuplicating = true
      let selectedRow = this.hot.getSelectedLast()[0]
      let rowData = this.hot.getDataAtRow(selectedRow)
      let id = rowData[0]

      let duplicateData = await serviceRoutes.duplicateTestRecord(this.chunkId, id)
      console.log('duplicate done')
      await serviceRoutes.updateTestRecords(
        this.chunkId,
        [{ _id: id, is_duplicated_by_user: true }]
      )
      console.log('update duplicate done')

      let nextRow = null
      this.hotSettings.data = this.hotSettings.data.map((rec, index) => {
        if (rec._id === id) {
          rec.is_duplicated_by_user = true
          nextRow = index + 1
          rec = Object.assign({}, rec)
        }
        return rec
      })

      let data = this.hotSettings.data.slice(0)
      data.splice(nextRow, 0, duplicateData.data)
      this.hotSettings.data = data
      this.hot.loadData(data)

      this.filter()
      this.isDuplicating = false
      console.timeEnd('duplicate')
    },
    init () {
      const rawData = this.rawData
      const header = rawData.format.showColumns
      let dataRecords = rawData.records.slice(0)
      let headerData = []
      let columnData = []
      let colWidth = []
      let hiddenColumns = []
      let index = 0
      for (let key of header) {
        if (key.visible) {
          headerData.push(key.col_header)
          colWidth.push(key.width ? key.width : 120)
          columnData.push({
            data: key.col_key,
            type: key.col_type,
            source: key.data ? key.data : null,
            strict: true,
            allowInvalid: false,
            wordWrap: false,
            readOnly: key.disable ? key.disable : null,
            allowEmpty: false
          })
          if (key.hidden) {
            hiddenColumns.push(index)
          }
          index++
        }
      }
      this.hotSettings.colWidths = colWidth
      this.hotSettings.colHeaders = headerData
      this.hotSettings.columns = columnData
      this.hotSettings.hiddenColumns = {
        copyPasteEnabled: true,
        indicators: true,
        columns: hiddenColumns
      }

      this.hotSettings.data = JSON.parse(JSON.stringify(dataRecords))
      this.hot = new Handsontable(this.$refs.table, this.hotSettings)
      this.initDefaultFilter()
      this.countRow = this.hot.getData() ? this.hot.getData().length : 0
    },
    mapDataArrayToObject (dataCol) {
      const header = this.hotSettings.columns
      let data = {}
      for (let [idx, key] of header.entries()) {
        data[key.data] = dataCol[idx]
      }
      return data
    },
    mapObjectToDataArray (dataObj) {
      const header = this.hotSettings.columns
      let data = []
      for (let key of header) {
        data.push(dataObj[key.data])
      }
      return data
    },
    validateData (isSelectRow = false) {
      console.time('validate')
      this.invalidCell = []
      let that = this
      return new Promise((resolve, reject) => {
        let data = this.hot.getData().slice(0)

        this.hot.validateRows(data.map((v, i) => i), (valid) => {
          console.timeLog('validate')
          let isValid = valid

          let rows = data.map(d => that.mapDataArrayToObject(d))

          let channelIndex = that.hotSettings.columns.map(col => col.data).indexOf('Channel')
          let productIndex = that.hotSettings.columns.map(col => col.data).indexOf('Product/Other')

          for (let [idx, row] of rows.entries()) {
            if (row.Channel === 'mobile banking' && row['Product/Other'] === 'mobile banking') {
              that.hot.getCellMeta(idx, channelIndex).valid = false
              that.hot.getCellMeta(idx, productIndex).valid = false
              isValid = false
            }
          }
          that.hot.render()
          if (isSelectRow) {
            let invalidRow = this.invalidCell[this.invalidCell.length - 1]
            if (invalidRow >= 0) {
              that.hot.selectRows(invalidRow)
            }
          }
          console.timeEnd('validate')
          resolve(isValid)
        })
      })
    },
    initDefaultFilter () {
      const filtersPlugin = this.hot.getPlugin('filters')
      filtersPlugin.clearConditions()
      // filtersPlugin.addCondition(1, 'neq', ['Delete'], 'disjunction')
      filtersPlugin.addCondition(1, 'by_value', [['New', 'Read']])
      filtersPlugin.filter()
    },
    undo () {
      let todos = this.undoHistory.pop()
      if (todos) {
        for (let record of todos) {
          this.hotSettings.data = this.hotSettings.data.map(v => {
            if (v._id === record._id) {
              v = Object.assign({}, record)
              this.updateRecords({ chunkId: this.chunkId, records: [record] })
            }
            return v
          })
        }
        this.hot.loadData(this.hotSettings.data)
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
      }
    },
    filter () {
      setImmediate(() => {
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
      })
    },
    tagging () {
      // this.$socket.emit('tagging', { chunkId: this.chunkId })
    },
    async getUndeletedPages () {
      serviceRoutes.getUndeletedPages().then((res) => {
        let pages = res.data.data || []
        this.unDeletedPages = pages.map(v => v.page_name.toLowerCase())
      }).catch(() => {
        console.log('Cannot get undeleted page')
      })
    },
    checkKeyword () {
      if (!this.text) return

      this.isCheckKeyword = true
      this.matchKeywordInfo = null
      let data = {
        account: 'kbank',
        msg: this.text
      }
      serviceRoutes.keywordChecker(data).then(res => {
        if (res.data.data) {
          const isMatch = res.data.data.is_match
          const matchedKeyword = res.data.data.matched_keyword || []
          const matchedExcludedKeyword = res.data.data.matched_excluded_keyword || []
          const categoryLevels = res.data.data.levels || []

          const levelLabel = ['Brand', 'Channel', 'Product', 'Sub Attribute', 'Intention']

          let levelFilter = categoryLevels.map((levelInfos, index) => {
            return { level: index, label: levelLabel[index], categories: levelInfos ? levelInfos.filter(category => category.matchingWords.length) : [] }
          }).filter(v => v.categories.length)

          this.matchKeywordInfo = {
            isMatch, matchedKeyword, matchedExcludedKeyword, levels: levelFilter
          }
        }
        this.isCheckKeyword = false
      }).catch((err) => {
        console.error(err)
        this.isCheckKeyword = false
      })
    }
  }
}
</script>
<style scoped>
.text-info-area {
  word-break:break-all;
  resize: both;
  overflow: auto;
  border: solid 1px;
  padding: 10px;
  height:90px;
  max-width:100%;
}
</style>

<style>
.ht_editor_visible textarea{
  width:auto !important;
}
</style>
